import { render, staticRenderFns } from "./MailSettings.vue?vue&type=template&id=0273c87f&scoped=true"
import script from "./MailSettings.vue?vue&type=script&lang=js"
export * from "./MailSettings.vue?vue&type=script&lang=js"
import style0 from "./MailSettings.vue?vue&type=style&index=0&id=0273c87f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273c87f",
  null
  
)

export default component.exports